/**
 * Head component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { StaticQuery, graphql } from "gatsby";

export const Meta = ({ description, lang, meta, links, pageTitle, site }) => {
  const { siteMetadata } = site ? site : { siteMetadata: {title: "", description: ""}};
  const metaDescription = description || siteMetadata.description;
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={pageTitle}
      titleTemplate={`%s | ${siteMetadata.title}`}  // "Home | YAYASEB"
      meta={[
        {
          name: "description",
          content: metaDescription,
        },
        {
          property: "og:title",
          content: pageTitle,
        },
        {
          property: "og:description",
          content: metaDescription,
        },
        {
          property: "og:type",
          content: "website",
        },
      ].concat(meta)}
      link={[{
        type: "text/css",
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&family=Lora:ital,wght@0,400;0,700;1,400;1,700&display=swap",
      }].concat(links)}
    />

  );
};

Meta.defaultProps = {
  description: "",
  lang: "en",
  links: [],
  meta: [],
};
Meta.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  lang: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.object),
  meta: PropTypes.arrayOf(PropTypes.object),
  site: PropTypes.shape({
    siteMetadata: PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
    }),
  }),
};

const Head = (props) => {
  return (
    <StaticQuery
      render={data => <Meta site={data.site} {...props} />}
      query={
        graphql`query {
          site {
            siteMetadata {
              description
              title
            }
          }
        }`
      }
    />
  );
};

Head.defaultProps = { ...Meta.defaultProps };
Head.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  lang: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.object),
  meta: PropTypes.arrayOf(PropTypes.object),
};

export default Head;
